
export default function NeighbourhoodHeroSection() {
  return (
    <section 
      className="relative bg-dark-950 text-white min-h-[60vh] flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.8), rgba(185, 28, 28, 0.4)), url('https://public.readdy.ai/ai/img_res/a4f5e62e3af285766a95d1f8f826f3b3.jpg')`
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-20">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
            Neighbourhood <span className="text-red-400">Guides</span>
          </h1>
          <p className="text-xl sm:text-2xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
            Explore housing markets, schools, and amenities across Waterloo, Brant County, and Wellington County.
          </p>
          <div className="flex flex-wrap justify-center gap-6 pt-8">
            <div className="flex items-center gap-2 text-gray-300">
              <i className="ri-map-pin-line text-red-400 text-xl"></i>
              <span>Local Market Insights</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300">
              <i className="ri-school-line text-red-400 text-xl"></i>
              <span>School Information</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300">
              <i className="ri-community-line text-red-400 text-xl"></i>
              <span>Community Amenities</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
